var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 261.61,
    height: 261.61,
    viewBox: "0 0 261.61 261.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.925,
    y1: 0.925,
    x2: 0.075,
    y2: 0.075,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00cdc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6154c7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_59",
    x: 0,
    y: 0,
    width: 261.61,
    height: 261.61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.11,
    dy: 6.11,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.182,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accountability",
    transform: "translate(-161.296 -5344.617)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 161.3, 5344.62)",
    filter: "url(#Rectangle_59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59-2",
    "data-name": "Rectangle 59",
    width: 248.517,
    height: 248.517,
    rx: 63.606,
    transform: "translate(0.44 0.44)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 41.064,
    height: 20.778,
    rx: 3.179,
    transform: "translate(264.395 5384.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M334.852,5396.288h-25.3c-.234,4.494,1.7,13.626-5.573,13.453H265.9c-7.239.183-5.387-8.974-5.573-13.453h-23.2c-4.4,0-7.97,3.3-7.97,7.367v143.093c0,4.069,3.568,7.367,7.97,7.367h97.723c4.4,0,7.97-3.3,7.97-7.367V5403.655C342.822,5399.587,339.254,5396.288,334.852,5396.288Zm-60.7,108.568c-1.77,1.318-12.694,16.477-15.3,15.635-2.091.322-6.878-5.131-8.425-6.148-3.582-3.049,1.264-8.612,4.774-5.481l3.313,2.884,10.145-11.663C271.714,5496.486,277.276,5501.346,274.148,5504.856Zm0-29.628c-1.77,1.318-12.694,16.476-15.3,15.634-2.091.323-6.878-5.13-8.425-6.147-3.582-3.05,1.264-8.612,4.774-5.482l3.313,2.884,10.145-11.662C271.714,5466.857,277.276,5471.718,274.148,5475.228Zm0-29.629c-1.77,1.318-12.694,16.477-15.3,15.635-2.091.322-6.878-5.131-8.425-6.148-3.582-3.049,1.264-8.612,4.774-5.481l3.313,2.883,10.145-11.662C271.714,5437.228,277.276,5442.089,274.148,5445.6Zm46.3,67.287H288.161a3.222,3.222,0,0,1,0-6.443H320.45C324.617,5506.39,324.634,5512.939,320.45,5512.886Zm0-29.629H288.161a3.221,3.221,0,0,1,0-6.443H320.45C324.617,5476.761,324.634,5483.311,320.45,5483.257Zm0-29.629H288.161a3.221,3.221,0,1,1,0-6.442H320.45C324.617,5447.133,324.634,5453.682,320.45,5453.628Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountability);
export default __webpack_public_path__ + "static/media/Accountability.79fe5662fbc760a1870065a50ad8253d.svg";
export { ForwardRef as ReactComponent };